import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from "../../../../Common";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi, { x } from "@hapi/joi";
import { LentLabourReportSchemaObject } from "../LentLabourReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from "./createPdf";
import _, { isNumber } from "lodash";
import "../../../Common/Table/table.css";
import xlsx from "json-as-xlsx";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Box from "@material-ui/core/Box";
import MessageModal from "../../../../UI/Modal/MessageModal";
import moment from 'moment';

const screenCode = "LENTLABOURREPORT";

export function LentLabourListing(props) {
  const componentRef = useRef();
  const [divisions, setDivisions] = useState([]);
  const [groups, setGroups] = useState([]);
  const [estates, setEstates] = useState([]);
  const [multipleEstates, setMultipleEstates] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);

  const [isTableHide, setIsTableHide] = useState(true);

  const [lentLabourDetails, setLentLabourDetails] = useState({
    groupID: "0",
    estateID: "0",
    divisionID: "0",
    searchDate:  moment().format('YYYY-MM-DD'),
  });

  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupID: "0",
    estateID: "0",
    division: "0",
    searchDate:  moment().format('YYYY-MM-DD'),
  });
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "",
    disciption: "",
  });
  const [errors, setErrors] = useState({});

  const [permissionList, setPermissions] = useState({
    isAddEditEnabled: false,
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });

  const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
  const [buttonHide, setButtonHide] = useState(true);

  const schema = Joi.object(LentLabourReportSchemaObject).options({
    allowUnknown: true,
  });

  const [csvHeaders, setCsvHeaders] = useState([
    { label: "Employee Number", value: "empNo" },
    { label: "Employee Name", value: "empName" },
    { label: "Lent Estate", value: "transferEstate" },
    { label: "Lent Division", value: "transferDivision" },
  ]);

  const [reportData, setReportData] = useState([]);

  useEffect(() => {
    trackPromise(getPermissions(), getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getEstatesForDropdown());
    setReportData([]);
  }, [lentLabourDetails.groupID]);

  useEffect(() => {
    trackPromise(getDivisionsForDropDown());
    setReportData([]);
    setLentLabourDetails(prev => ({
      ...prev,
      searchDate: moment().format('YYYY-MM-DD')
    }));
  }, [lentLabourDetails.estateID]);

  useEffect(() => {
    setReportData([]);
    setLentLabourDetails(prev => ({
      ...prev,
      searchDate: moment().format('YYYY-MM-DD')
    }));
  }, [lentLabourDetails.divisionID]);

  useEffect(() => {
    setReportData([]);
  }, [lentLabourDetails.searchDate]);

  useEffect(() => { }, [reportData]);


  function handleGroupChange(target) {
    validateInputs(target);

    setLentLabourDetails({
      ...lentLabourDetails,
      groupID: target.value,
      estateID: "0",
      fieldID: "0",
    });
  }

  function handleEstateChange(target) {
    validateInputs(target);

    setLentLabourDetails({
      ...lentLabourDetails,
      estateID: target.value,
      divisionID: "0",
    });
  }
  function handleDivisionChange(target) {
    validateInputs(target);

    setLentLabourDetails({
      ...lentLabourDetails,
      divisionID: target.value,
    });
  }

  function handleSearchDateChange(target) {
    validateInputs(target);
    setIsReportButtonsEnabled(false);
    setLentLabourDetails({
      ...lentLabourDetails,
      searchDate: target.value,
    });
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(
      target,
      LentLabourReportSchemaObject
    );
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "VIEWLENTLABOURREPORT"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }
    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );

    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });
    var token = tokenService.getUserDetailsFromTokenV2();

    if (token.operationEntities.length > 0) {

      var estateArray = [];
      for (let item of Object.entries(token.operationEntities)) {
        estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
      }

      setMultipleEstates(estateArray)

      setLentLabourDetails({
        ...lentLabourDetails,
        groupID: token.groupID
      });

    } else {
      setLentLabourDetails({
        ...lentLabourDetails,
        groupID: token.groupID,
        estateID: token.operationEntityID,
      });
    }

    setLentLabourDetails({
      ...lentLabourDetails,
      groupID: token.groupID,
      estateID: token.operationEntityID,
    });
    trackPromise(getGroupsForDropdown());
  }

  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getEstatesForDropdown() {
    const data = await services.getEstatesByGroupID(
      lentLabourDetails.groupID
    );
    setEstates(data);
  }

  async function getDivisionsForDropDown() {
    const data = await services.getDivisionByEstateID(
      lentLabourDetails.estateID
    );
    setDivisions(data);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }


  async function handleSearch(e) {
    e.preventDefault();
    setIsTableHide(true);
    const errorMessages = validate(schema, lentLabourDetails)
    errorMessages !== null ? setErrors(errorMessages) : setErrors({})
    if (errorMessages) return;

    getSelectedDropdownValuesForReport(lentLabourDetails);
    var reportData = await services.getLentLabourReportData(lentLabourDetails);
    if (reportData.length > 0) {
      setReportData(reportData);
      setIsTableHide(false);
      destroyDataTable();
      setIsReportButtonsEnabled(true);
      setButtonHide(false);
    } else {
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: "Error",
        disciption: "No Records To Display",
      });
      setTimeout(() => {
        modalDismissHandler();
      }, 3000);
    }

  }


  function createFile() {
    var settings = {
      sheetName: "Lent Labour Report",
      fileName: "LentLabourReport",
      writeOptions: {},
    };

    var copyOfCsv = _.cloneDeep(reportData);

    copyOfCsv.push({});

    copyOfCsv.push({
      empNo: "Group :" + groups[lentLabourDetails.groupID],
      empName: "Operation Entity : " + estates[lentLabourDetails.estateID],
      transferEstate: "Collection Point : " + divisions[lentLabourDetails.divisionID],
      transferDivision: "Date : " + lentLabourDetails.searchDate,
    });
    xlsx(csvHeaders, copyOfCsv, settings, true);
  }


  function destroyDataTable() {
    $("#example3").DataTable().destroy();
  }

  function onCancelClick() {
    clearState();
  }

  function clearState() {
    setLentLabourDetails({
      ...lentLabourDetails,
      divisionID: "0",
      searchDate: "",
    });
    setIsTableHide(true);
    setErrors("");
    setIsReportButtonsEnabled(true);
    setButtonHide(true);
    setReportData([]);

  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      group: groups[searchForm.groupID],
      estate: estates[searchForm.estateID],
      division: divisions[searchForm.divisionID],
      searchDate: searchForm.searchDate,
    });
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <PageHeader
              title="Lent Labour Report"
              isButtonEnable={permissionList.isAddEditEnabled}
            />
            <div className="card-body">
              <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                <div className="form-group row">
                  <div className="col-md-3">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="groupID"
                      id="groupID"
                      name="groupID"
                      value={lentLabourDetails.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>
                  <div className="col-md-3">
                    <InputLabel shrink id="estateID">
                      Operation Entity *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="estateID"
                      id="estateID"
                      name="estateID"
                      value={lentLabourDetails.estateID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleEstateChange(e.target)}
                    >
                      <MenuItem value="0">--Select Operation Entity--</MenuItem>
                        {generateDropDownMenu(multipleEstates.length == 0 ? estates : multipleEstates)}
                    </Select>
                    {errors["estateID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["estateID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md-3">
                    <InputLabel shrink id="">
                      Collection Point*
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="divisionID"
                      id="divisionID"
                      name="divisionID"
                      value={lentLabourDetails.divisionID}
                      onChange={(e) => handleDivisionChange(e.target)}
                    >
                      <MenuItem value="0">--Select Collection Point--</MenuItem>
                      {generateDropDownMenu(divisions)}
                    </Select>
                    {errors["divisionID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["divisionID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md-3">
                    <InputLabel shrink id="searchDate">
                      Search Date *
                    </InputLabel>
                    <TextField
                      fullWidth
                      id="searchDate"
                      name="searchDate"
                      type="date"
                      value={lentLabourDetails.searchDate}
                      onChange={(e) => handleSearchDateChange(e.target)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors["searchDate"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["searchDate"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>
                <div className="card-footer">
                  <input
                    disabled={validate(schema, lentLabourDetails)}
                    type="button"
                    className="btn btn-primary"
                    value="Search"
                    onClick={(e) => trackPromise(handleSearch(e))}
                  />

                  <input
                    type="reset"
                    className="btn btn-warning pull-right"
                    value="Clear"
                    onClick={onCancelClick}
                  />
                </div>
              </form>

              {reportData.length != 0 ? (
                <div>
                  <div className="row">
                    <div className="col-md-12">
                      <div>
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                              <TableHead>
                                <TableRow style={{ border: "2px solid black" }}>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Employee Number</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Employee Name</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Lent Estate</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Lent Division</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {reportData.slice(page * limit, page * limit + limit).map((row, i) => (
                                  <TableRow key={i} style={{ border: "2px solid black" }}>
                                    <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black" }}>{row.empNo}</TableCell>
                                    <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.empName}</TableCell>
                                    <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.transferEstate}</TableCell>
                                    <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.transferDivision}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Box>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            {reportData.length != 0 ? (
              <div className="pt-2">
                <ReactToPrint
                  trigger={() => (
                    <input
                      type="button"
                      className="btn btn-primary pull-right ml-2"
                      value="PDF"
                    />
                  )}
                  content={() => componentRef.current}
                />
                <div hidden={true}>
                  <CreatePdf
                    ref={componentRef}
                    reportData={reportData}
                    searchData={selectedSearchValues}
                  />
                </div>{" "}
                <input
                  type="button"
                  className="btn btn-primary pull-right ml-2"
                  value="Excel"
                  onClick={createFile}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
        clicked={modalDismissHandler}
      />
    </Fragment>
  );
}
